import React from 'react'
import { Checkbox as MuiCheckbox } from '@material-ui/core'
import { ReactComponent as UncheckedSvg } from './unchecked.svg'
import { ReactComponent as CheckedSvg } from './ticket.svg'

export const Checkbox = (props) => {
	return <MuiCheckbox icon={<UncheckedSvg fill="currentColor" />} checkedIcon={<CheckedSvg fill="currentColor" />} {...props} />
}
